export enum InvoiceStatusForms {
  MarkInvoicesSentForm = 'MarkInvoicesSentForm',
}
